import React, { useState, useMemo, useEffect } from 'react';
import {
  Button,
  Typography,
  TextField,
  Menu,
  MenuItem,
} from '@material-ui/core';
import CirclePlusIcon from '@material-ui/icons/AddCircleOutline';
import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import { Formik } from 'formik';
import { useRootStore } from '../../../../stores/BridgeProvider';
import { StyledForm, ButtonFlex, FormRow } from '../../../styles/styles';
import SimpleSelect from '../../../util/SimpleSelect';
import FieldModal from './FieldModal';
import RenderPropModal from '../../../dealMapper/common/RenderPropModal';

const DealStyle = css`
  .dealFields {
    margin-left: 10px;
  }
  margin-bottom: 10px;
`;

const DisabledInputStyles = css`
  .MuiFormLabel-root.Mui-disabled {
    color: #757575;
  }
  .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
    border-color: rgba(0, 0, 0, 0.15);
  }

  :hover {
    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: rgba(0, 0, 0, 0.35);
    }
  }
`;

const DealFormPreview = ({ deal, json, updateTemplateJSON }) => {
  const { template, items } = json;
  const [selectedField, setSelectedField] = useState({});
  //   AgentContactName: '$AgentContactName';
  //   BillableDate: '$TransactionDate';
  //   ContractDate: '%CurrentDate';
  //   DealNumber: 'AUTO-GENERATE';
  //   Description: '$Description';
  //   PayableDate: '$TransactionDate';
  //   StatusName: '$StatusName';
  //   Title: '$Title';
  //   TransactionDate: '$TransactionDate';
  return (
    <Formik
      initialValues={deal}
      enableReinitialize
      // validationSchema={DealTemplateSchema(items)}
      onSubmit={async (values, { resetForm, setSubmitting }) => {
        try {
          updateTemplateJSON({
            template: {
              Deals: [{ ...values }],
              DealTransactions: json.template.DealTransactions,
            },
            items: json.items,
          });
          // resetForm();
        } catch (e) {
          console.error(e);
        }
        setSubmitting(false);
        // setLoading(false);
      }}
      render={formikProps => {
        const {
          handleSubmit,
          isSubmitting,
          isValid,
          handleChange,
          handleBlur,
          values,
          setFieldValue,
          dirty,
        } = formikProps;

        return (
          <RenderPropModal
            cardDisplay={({ handleClose }) => (
              <FieldModal
                handleClose={handleClose}
                setValueForParent={setFieldValue}
                selectedField={selectedField}
                setSelectedField={setSelectedField}
                items={items}
                updateTemplate={handleSubmit}
              />
            )}
          >
            {({ handleOpen }) => (
              <StyledForm
                style={{
                  alignItems: 'inherit',
                }}
                css={DealStyle}
                // onSubmit={handleSubmit}
              >
                <div className="dealFields">
                  <FormRow>
                    <TextField
                      name="Title"
                      label="Title"
                      value={values.Title || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'Title',
                          label: 'Title',
                          curVal: values.Title,
                          fieldType: 'string',
                        });
                        handleOpen();
                      }}
                    />
                    <TextField
                      name="StatusName"
                      label="Status"
                      value={values.StatusName || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'StatusName',
                          label: 'Status',
                          curVal: values.StatusName,
                          fieldType: 'enum',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>
                  <FormRow>
                    <TextField
                      name="DealNumber"
                      label="Deal Number"
                      value={values.DealNumber || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'DealNumber',
                          label: 'Deal Number',
                          curVal: values.DealNumber,
                          fieldType: 'string',
                        });
                        handleOpen();
                      }}
                    />
                    <TextField
                      name="AgentContactName"
                      label="Agent Contact Name"
                      value={values.AgentContactName || ''}
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'AgentContactName',
                          label: 'Agent Contact Name',
                          curVal: values.AgentContactName,
                          fieldType: 'agent',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>
                  <FormRow>
                    <TextField
                      name="BillableDate"
                      label="Billable Date"
                      value={values.BillableDate || ''}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      onClick={() => {
                        setSelectedField({
                          name: 'BillableDate',
                          label: 'Billable Date',
                          curVal: values.BillableDate,
                          fieldType: 'date',
                        });
                        handleOpen();
                      }}
                    />
                    <TextField
                      name="ContractDate"
                      label="Contract Date"
                      value={values.ContractDate || ''}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      onClick={() => {
                        setSelectedField({
                          name: 'ContractDate',
                          label: 'Contract Date',
                          curVal: values.ContractDate,
                          fieldType: 'date',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>
                  <FormRow>
                    <TextField
                      name="PayableDate"
                      label="Payable Date"
                      value={values.PayableDate || ''}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      onClick={() => {
                        setSelectedField({
                          name: 'PayableDate',
                          label: 'Payable Date',
                          curVal: values.PayableDate,
                          fieldType: 'date',
                        });
                        handleOpen();
                      }}
                    />
                    <TextField
                      name="TransactionDate"
                      label="Transaction Date"
                      value={values.TransactionDate || ''}
                      margin="normal"
                      variant="outlined"
                      fullWidth
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      onClick={() => {
                        setSelectedField({
                          name: 'TransactionDate',
                          label: 'Transaction Date',
                          curVal: values.TransactionDate,
                          fieldType: 'date',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>
                  <FormRow>
                    <TextField
                      name="Description"
                      label="Description"
                      value={values.Description || ''}
                      margin="normal"
                      disabled
                      inputProps={{
                        style: {
                          cursor: 'pointer',
                          color: '#263238',
                        },
                      }}
                      floatingLabelStyle={{
                        color: '#757575 !important',
                      }}
                      css={DisabledInputStyles}
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setSelectedField({
                          name: 'Description',
                          label: 'Description',
                          curVal: values.Description,
                          fieldType: 'string',
                        });
                        handleOpen();
                      }}
                    />
                  </FormRow>
                </div>
              </StyledForm>
            )}
          </RenderPropModal>
        );
      }}
    />
  );
};

export default DealFormPreview;
